import React from "react";
import { SecondaryButton, formatSquadInfo } from "../../../UI/DesignStandards";
import { FaFilter, FaSearch } from "react-icons/fa";
import QuickFilters from "./QuickFilters";
import ActiveFilters from "./ActiveFilters";
import { dashboardCounts } from "../../../../utility/signupDashboard";

const FILTER_LABELS = {
  on_squad: "On squad",
  waitlist: "Waitlist",
  due: "Due",
  paid: "Paid",
  cancelled: "Cancelled",
  all: "All",
};

const SignupFilters = ({
  showFilters,
  setShowFilters,
  filters,
  searchTerm,
  setSearchTerm,
  signups,
  clearFilters,
  setQuickFilter,
  removeFilter,
  handleFilterChange,
}) => {
  const getUniqueEvents = () => {
    return [
      ...new Set(
        signups.map((signup) => signup.tournamentEvents?.eventName).filter(Boolean)
      ),
    ];
  };

  const getUniqueSquads = () => {
    const seen = new Set();
    const squads = [];
    signups.forEach((signup) => {
      const squad = signup.squads;
      const id = squad?.id || signup.squadId;
      if (!id || seen.has(id)) return;
      seen.add(id);
      squads.push({
        id,
        label: formatSquadInfo(squad?.squadDate, squad?.squadTime),
        sort: `${squad?.squadDate || ""} ${squad?.squadTime || ""}`,
      });
    });
    return squads.sort((a, b) => a.sort.localeCompare(b.sort));
  };

  return (
    <>
      <div className="flex justify-end mb-4">
        <SecondaryButton
          onClick={() => setShowFilters(!showFilters)}
          className="flex items-center gap-2"
        >
          <FaFilter className="w-4 h-4" />
          {showFilters ? "Hide filters" : "Filters"}
        </SecondaryButton>
      </div>

      <QuickFilters
        currentStatus={filters.status}
        onStatusChange={setQuickFilter}
        counts={dashboardCounts(signups)}
      />

      <ActiveFilters
        filters={filters}
        searchTerm={searchTerm}
        onRemoveFilter={removeFilter}
        onClearAll={clearFilters}
        statusLabels={FILTER_LABELS}
        squadLabel={
          getUniqueSquads().find((squad) => squad.id === filters.squad)?.label
        }
      />

      {showFilters ? (
        <div className="pt-4 border-t border-brand-charcoal/10">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div>
              <label className="block text-sm font-medium text-brand-charcoal mb-2">
                Search
              </label>
              <div className="relative">
                <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-brand-muted w-4 h-4" />
                <input
                  type="text"
                  placeholder="Name or email"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="pl-10 w-full border border-brand-charcoal/20 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-brand-gold-ink"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-brand-charcoal mb-2">
                Status
              </label>
              <select
                value={filters.status}
                onChange={(e) => handleFilterChange("status", e.target.value)}
                className="w-full border border-brand-charcoal/20 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-brand-gold-ink"
              >
                <option value="all">All</option>
                <option value="on_squad">On squad</option>
                <option value="waitlist">Waitlist</option>
                <option value="due">Due</option>
                <option value="paid">Paid</option>
                <option value="cancelled">Cancelled</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-brand-charcoal mb-2">
                Event
              </label>
              <select
                value={filters.event}
                onChange={(e) => handleFilterChange("event", e.target.value)}
                className="w-full border border-brand-charcoal/20 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-brand-gold-ink"
              >
                <option value="all">All events</option>
                {getUniqueEvents().map((event) => (
                  <option key={event} value={event}>
                    {event}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-brand-charcoal mb-2">
                Squad
              </label>
              <select
                value={filters.squad}
                onChange={(e) => handleFilterChange("squad", e.target.value)}
                className="w-full border border-brand-charcoal/20 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-brand-gold-ink"
              >
                <option value="all">All squads</option>
                {getUniqueSquads().map((squad) => (
                  <option key={squad.id} value={squad.id}>
                    {squad.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default SignupFilters;
